import session from 'lib/session';
import { createReducer, field } from 'redux/shelf';
import { del, get, post, put, search } from 'redux/shelf/api';

export const actions = {
  fetchAll: get`smart-collections/${session.getMerchant}`(),
  fetch: get`smart-collections/${session.getMerchant}/:id`(),
  update: put`smart-collections/${session.getMerchant}/:id`(),
  bulkUpdate: put`smart-collections/${session.getMerchant}/batch`(),
  bulkRemove: del`smart-collections/${session.getMerchant}/batch`(),
  remove: del`smart-collections/${session.getMerchant}/:id`(),
  create: post`smart-collections/${session.getMerchant}`(),
  fetchFacets: search.post`/facet/values`(field('facets')),
  importCollection: post`smart-collections/sync`(field('status')),
  updateCollection: post`smart-collections/sync?updateExisting=true`(
    field('status')
  ),
  fetchSyncHistory:
    get`smart-collections/${session.getMerchant}/:id/sync/history`(),
  importFile: post`smart-collections/${session.getMerchant}/upload`(),
};

export const reducer = createReducer(actions, {
  [actions.remove]: (s, { meta }) => ({
    ...s,
    entities: s.entities.filter((_, i) => i !== meta.index),
  }),
  [actions.update]: (s, { payload }) => ({
    ...s,
    entities: s.entities.map((e) =>
      payload && payload.entity && e.id === payload.entity.id
        ? payload.entity
        : e
    ),
  }),
  [actions.fetchSyncHistory]: (s, { payload }) => ({
    ...s,
    syncHistory: payload.entities.map((i) => ({ ...i, syncAction: i.action })),
  }),
});

export const newFiltersEnabled = (collection) =>
  !!(collection && collection.filtersNew.operator);

export const cleanCollectionSlot = (slot) => {
  let removeDomain = slot.replace(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i, '');
  if (removeDomain.indexOf('/') === 0) {
    removeDomain = removeDomain.slice(1);
  }

  if (removeDomain[removeDomain.length - 1] === '/') {
    removeDomain = removeDomain.slice(0, removeDomain.length - 1);
  }

  return removeDomain;
};
